module.exports = __webpack_public_path__ + "img/3.983b7e14.jpg";